module.exports = __webpack_public_path__ + "static/lachat_mario_2-a3761630f5891dbc821352ef92027195.png";